import request from "@/utils/request";

export default function agentCreatCarport(data) {
    return request({
        url: `/device/carport/agentCreatCarport`,
        method: 'post',
        data
    })
}
